export default "__VITE_ASSET__b6fRHD5Z__"